import { api } from 'shared/sdk';

export const TABS = {
  VENDORS: {
    label: 'PropTech Companies',
    title: 'Featured PropTech Companies',
    url: api.featuredCompaniesList
  },
  INVESTORS: {
    label: 'PropTech Investors',
    title: 'Recently Added PropTech Investors',
    url: api.investorList
  },
  SERVICE_PROVIDERS: {
    label: 'Service Providers',
    title: 'Recently Added Service Providers',
    url: api.serviceProvidersList
  }
};
